import Grid, { GridTypeMap } from "@mui/material/Grid";
import { OverridableComponent } from "@mui/material/OverridableComponent";

export const Row: OverridableComponent<GridTypeMap> = ({
  basePath,
  ...props
}: any) => <Grid container {...props} style={{ width: "100%" }} />;

export const Col: OverridableComponent<GridTypeMap> = ({
  basePath,
  ...props
}: any) => <Grid item {...props} />;
